<template>
  <vs-popup class="refund-popup" title="Issue Refund" :active.sync="refundPopupConfig.isOpen">
    <div class="overflow-auto">
      <div class="sm:flex align-center justify-between mt-6 mb-base" v-if="refundPopupConfig.item_info">
        <p>
          Name: <span class="text-lg text-black font-bold mx-3">{{ refundPopupConfig.item_info.customer_name }}</span>
          {{ StringHelper.phoneNumberFormat(refundPopupConfig.item_info.customer_phone) }}
        </p>
        <p class="sm:ml-6 sm:mt-0 mt-6">
          Deposit: <span class="text-lg text-black font-bold ml-3">${{
            refundPopupConfig.item_info.amount / 100
          }}</span>
        </p>
      </div>
      <div class="sm:flex align-center justify-between mb-base">
        <div class="sm:flex justify-center align-center">
          <p :class="{'mb-6 pb-1': valid_input.amount.has_err}">Refund</p>
          <vs-input min="0" :max="refund_max" class="refund-amount-input sm:my-0 my-2" v-model="refund_amount"
                    v-on:keypress="isNumber($event)" @blur="calcPercentage" :danger="valid_input.amount.has_err"
                    :danger-text="valid_input.amount.message"/>
        </div>
        <p class="text-right">{{ refund_percentage && refund_percentage != "" ? refund_percentage : 0 }}%</p>
      </div>
      <div class="sm:flex align-center justify-start mb-base reason-block">
        <p :class="{'mb-6 pb-1': valid_input.reason.has_err}">Reason</p>
        <div class="sm:pt-0 pt-2">
          <v-select label="label" v-model="selected_reason" :options="reasonOptions" :clearable="false"
                    :searchable="false" :class="{'invalid-border': valid_input.reason.has_err}"
                    @input="valid_input.reason = noErrObj"></v-select>
          <span class="text-danger text-sm error-text-input sm:ml-base"
                v-if="valid_input.reason.has_err">{{ valid_input.reason.message }}</span>
        </div>
      </div>
      <!-- <transition name="list">
          <div class="flex-center justify-start mb-6" v-show="selected_reason.id == 2">
              <p class="visibility-hidden">Reason</p>
              <vs-textarea class="other-reason" placeholder="Your reason" />
          </div>
      </transition> -->
      <p class="text-black font-bold text-center mb-base">${{ refund_amount }} will be refunded to
        <span v-if="itemInfo && itemInfo.detail_info && itemInfo.detail_info.source">
          {{ itemInfo.detail_info.source.brand }} ending in {{ itemInfo.detail_info.source.last4 }}
        </span>
        <span v-else>N/A</span>
      </p>
      <div class="text-center px-12 py-3 mb-4 rounded-item notice-block">
        <p><span class="text-underline">Notice:</span> Refunds take 5-10 days to appear on a customer’s statement</p>
      </div>
    </div>
    <div class="flex-center mb-base button-group">
      <vs-button class="ml-5 sm:mr-5 mr-0" @click="makeRefund">Refund</vs-button>
      <vs-button type="border" color="danger" class="mx-5" @click="refundPopupConfig.isOpen = false">Cancel</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import {StringHelper} from "../../models/string_helper";

export default {
  name: "refund-popup",
  components: {vSelect},
  props: {
    refundPopupConfig: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      StringHelper,
      reasonOptions: [
        {id: 0, label: 'Canceled appointment'},
        {id: 1, label: 'Incorrect charge'},
        {id: 2, label: 'Other'}
      ],
      selected_reason: {id: -1, label: 'Select a reason'},
      refund_amount: 0,
      refund_max: 0,
      refund_percentage: 100,
      valid_input: {
        amount: {
          has_err: false,
          message: ""
        },
        reason: {
          has_err: false,
          message: ""
        }
      },
      isOpenLoading: false,
      itemInfo: null,
    }
  },
  watch: {
    refundPopupConfig: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue.item_info) {
          this.refund_amount = newValue.item_info.balance / 100;
          this.refund_max = newValue.item_info.balance / 100;
          this.refund_percentage = 100;
          this.itemInfo = newValue.item_info;
        }
      }
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Refund Failed',
            acceptText: 'OK'
          })
        }
      }, 20000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    isNumber: function (evt) {
      this.valid_input.amount = this.noErrObj();
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)
        || (charCode == 46 && this.refund_amount.toString().indexOf(".") != -1)
        || ((charCode >= 48 && charCode <= 57) && this.refund_amount.toString().indexOf(".") != -1 && (this.refund_amount.toString().substring(this.refund_amount.toString().indexOf(".") + 1)).length == 2)
        || parseFloat(this.refund_amount + '' + evt.key) > this.refund_max) {
        evt.preventDefault();
      } else {
        if ((this.refund_amount === "0" || this.refund_amount === 0) && charCode != 46) {
          this.refund_amount = "";
        }

        if ((!this.refund_amount || this.refund_amount == "") && charCode == 46) {
          this.refund_amount = "0";
        }
        return true;
      }
    },
    calcPercentage() {
      let refund_percentage = parseFloat(this.refund_amount) / parseFloat(this.refund_max) * 100;
      this.refund_percentage = +(Math.round(refund_percentage + "e+2") + "e-2");
      this.formatNumber();
    },
    formatNumber() {
      let refund_amount = this.refund_amount && this.refund_amount != "" ? this.refund_amount : 0;
      this.refund_amount = parseFloat(refund_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

      if (refund_amount == 0) {
        this.valid_input.amount.has_err = true;
        this.valid_input.amount.message = "Refund amount must be greater than 0";
      }
    },
    noErrObj() {
      return {has_err: false, message: ""}
    },
    async makeRefund() {
      try {
        this.openLoadingInDiv();
        await this.$store.dispatch("appointment/MAKE_DEPOSIT_REFUND", {
          amount: Number(this.refund_amount) * 100,
          external_deposit_id: this.itemInfo.external_deposit_id,
          appointment_id: this.itemInfo.appointment_id,
          reason: this.selected_reason.value,
        });
        this.refundPopupConfig.isOpen = false;
        this.$vs.notify({
          title: "Notification",
          text: "Refund Success",
          color: "success",
          position: "top-right"
        });
        this.$emit("GetData");
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Notification",
          text: error.message,
          color: "danger",
          position: "top-right"
        });
      } finally {
        this.closeLoading();
      }
    }
  }
}
</script>
